import { Controller, useFormContext } from 'react-hook-form';
import SiteAdminWanListSelector from './SiteAdminWanListSelector';

export default function SiteAdminWanListSelectorField({
    gridColumns,
    selectedGridColumns,
    dbSelected,
    fieldName,
    selectedDataSource,
    selectedLoaderFunction,
    availableDataSource,
    availableLoaderFunction,
    availableSelectAll,
    idsDataSource,
    addButtonText,
    addButtonDisabled,
    removeButtonText,
    sorters,
    setSelectionIsDirty,
    isMultiRemove,
    selectedEmptyGridText,
    updateSelectionFunction,
}) {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={fieldName}
            render={() => (
                <SiteAdminWanListSelector
                    gridColumns={gridColumns}
                    selectedGridColumns={selectedGridColumns}
                    dbSelected={dbSelected}
                    selectedDataSource={selectedDataSource}
                    selectedLoaderFunction={selectedLoaderFunction}
                    availableDataSource={availableDataSource}
                    availableLoaderFunction={availableLoaderFunction}
                    availableSelectAll={availableSelectAll}
                    idsDataSource={idsDataSource}
                    fieldName={fieldName}
                    addButtonText={addButtonText}
                    addButtonDisabled={addButtonDisabled}
                    removeButtonText={removeButtonText}
                    sorters={sorters}
                    setSelectionIsDirty={setSelectionIsDirty}
                    isMultiRemove={isMultiRemove}
                    selectedEmptyGridText={selectedEmptyGridText}
                    updateSelectionFunction={updateSelectionFunction}
                />
            )}
        />
    );
}
